"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.roamingCharacsNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
const utils_common_to_kebap_case_1 = __importDefault(require("@gcloud-npm/utils.common.to-kebap-case"));
/**
 * normalizador del modulo LISTADO_MODULO_CARACTERISTIC_CARDS
 * @param {object} fields
 * @returns
 */
const roamingCharacsNormalizer = (data) => {
    var _a;
    try {
        let res = {};
        const toptitle = ((_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.title) || '';
        if (Array.isArray(data === null || data === void 0 ? void 0 : data.fields.listadoCaracteristicas)) { //new
            const normalizedInfo = {};
            data.fields.listadoCaracteristicas.forEach((element, i) => {
                var _a, _b;
                const { icon, title } = element === null || element === void 0 ? void 0 : element.fields;
                const listadoCards = (_a = element === null || element === void 0 ? void 0 : element.fields) === null || _a === void 0 ? void 0 : _a.ListadoCaracteristics;
                const typeMovil = (_b = element === null || element === void 0 ? void 0 : element.fields) === null || _b === void 0 ? void 0 : _b.typeMovil;
                const descCards = [];
                const card = {};
                if (icon) {
                    card["Glyph-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Glyph-1"]), { id: (0, utils_common_to_kebap_case_1.default)(icon) });
                }
                if (title) {
                    card["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-1"]), { text: title });
                }
                if (typeMovil) {
                    card["typeMovil"] = typeMovil;
                }
                listadoCards.map((item) => {
                    const { fields } = item;
                    const { title, description } = fields;
                    let descTitle = "";
                    let descSubtitle = "";
                    if (title) {
                        descTitle = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-2"]), { text: title });
                    }
                    if (description) {
                        descSubtitle = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-3"]), { text: description });
                    }
                    descCards.push({ title: descTitle, subTitle: descSubtitle });
                });
                card["Desc-1"] = descCards;
                const hasItems = Object.keys(card).length > 0;
                if (hasItems) {
                    normalizedInfo[`Charac-${i}`] = card;
                }
            });
            res = normalizedInfo;
        }
        res["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: toptitle });
        res["Name"] = data === null || data === void 0 ? void 0 : data.name;
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.roamingCharacsNormalizer = roamingCharacsNormalizer;
exports.default = exports.roamingCharacsNormalizer;
//# sourceMappingURL=index.js.map